module.exports = __webpack_public_path__ + "img/climate.b7b59335.svg";